<template>
    <v-layout class="component-wrap">
        <LiveNews />
    </v-layout>
</template>

<script>
import LiveNews from '@/components/view_blocks/Live_news/Live_news_wrap.vue';

export default {
  components: {
    LiveNews,
  },
};
</script>
